import { Box, Button, Stack, Typography } from '@mui/material';
import get from 'lodash-es/get';
import React, { forwardRef, Ref } from 'react';
import { useWatch } from 'react-hook-form';

import CanadaFlag from '../../assets/canada-flag-icon.svg';
import USAFlag from '../../assets/united-states-flag-icon.svg';
import { scrollTargetStyle } from '../../constants/style';
import { useConstants } from '../../hooks/useConstants';
import useVersions, { ModelType } from '../../hooks/useVersions';
import CheckboxArray from '../forms/CheckboxArray';
import FormSection from '../forms/FormSection';
import RadioGroup from '../forms/RadioGroup';
import TargetingAudiences from './TargetingAudiences/TargetingAudiences';
import TargetingSharedAppLists from './TargetingSharedAppLists/TargetingSharedAppLists';
import TargetingTactics from './TargetingTactics/TargetingTactics';

const FLAGS = {
  USA: USAFlag,
  CAN: CanadaFlag,
};

function AdGroupTargetingSection(_props: object, ref: Ref<HTMLDivElement>) {
  const adGroupId = useWatch({ name: 'id' });

  const { constants } = useConstants();
  const DEVICE_TYPE_TARGETING = get(constants, 'CAMPAIGN.DEVICE_TYPE_TARGETING', []).map((item) => ({
    value: item[0],
    label: item[1],
  }));
  const ACCEPTED_COUNTRIES = get(constants, 'CAMPAIGN.ACCEPTED_COUNTRIES', []).map((item) => ({
    value: item[0],
    label: (
      <Box display="flex" alignItems="center">
        <img alt={`${item[1]} flag icon`} src={FLAGS[item[0]]} style={{ height: '1rem' }} />
        &nbsp;&nbsp;{item[1]}
      </Box>
    ),
  }));

  const { openVersionsModal } = useVersions(ModelType.AdGroupTargeting, adGroupId);

  return (
    <FormSection
      title="Targeting"
      subTitle="I'd like to control my target inventory based on..."
      rightSection={
        <Button variant="text" disabled={!adGroupId} onClick={openVersionsModal}>
          See Changelog
        </Button>
      }
    >
      <div ref={ref} style={scrollTargetStyle} />
      <Stack spacing={1} alignItems="flex-start">
        <Stack direction="row" justifyContent="space-between" width="100%">
          <Button variant="text" disabled={!adGroupId} onClick={openVersionsModal}>
            See Changelog
          </Button>
        </Stack>
        <Typography>Country</Typography>
        <CheckboxArray row name="targetingProfile.device_countries" options={ACCEPTED_COUNTRIES} />
        <Typography>Type</Typography>
        <RadioGroup
          name="deviceTypeTargeting"
          options={DEVICE_TYPE_TARGETING}
          defaultValue={DEVICE_TYPE_TARGETING[0]?.value}
        />
        <TargetingTactics />
        <TargetingAudiences />
        <TargetingSharedAppLists />
      </Stack>
    </FormSection>
  );
}

export default React.memo(forwardRef(AdGroupTargetingSection));
